import { Phone, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import { COMPANY, MEDIA, waLink } from "@/lib/constants";

export const Footer = () => {
  return (
    <footer
      id="contato"
      data-testid="site-footer"
      className="bg-[#050505] border-t border-[#2d3748] pt-16 pb-24 md:pb-10 relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-1 siren-stripe"></div>

      <div className="container-custom">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-10 md:gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={MEDIA.logo}
                alt={COMPANY.fullName}
                className="h-16 w-16 object-contain"
              />
              <div>
                <div className="font-display uppercase font-bold text-white text-base leading-none">
                  Auto Socorro
                </div>
                <div className="font-display uppercase font-bold text-[#d90429] text-xl leading-none mt-1">
                  Ventania
                </div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Guincho e Auto Socorro 24 horas em Ribeirão Preto e região.
              Rapidez, segurança e compromisso em cada atendimento.
            </p>
          </div>

          <div>
            <h3 className="font-display uppercase tracking-wider text-white font-bold mb-5">
              Contato
            </h3>
            <ul className="space-y-4 text-gray-300 text-sm">
              <li>
                <a
                  href={`tel:${COMPANY.phoneTel}`}
                  data-testid="footer-phone"
                  className="flex items-start gap-3 hover:text-[#d90429] transition-colors"
                >
                  <Phone className="w-5 h-5 text-[#d90429] shrink-0 mt-0.5" />
                  <span>{COMPANY.phoneDisplay}</span>
                </a>
              </li>
              <li>
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="flex items-start gap-3 hover:text-[#25d366] transition-colors"
                >
                  <i className="fa-brands fa-whatsapp text-xl text-[#25d366] mt-0.5" aria-hidden></i>
                  <span>WhatsApp 24h</span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#d90429] shrink-0 mt-0.5" />
                <span>Atendimento 24 horas — 7 dias por semana</span>
              </li>
              <li>
                <a
                  href={COMPANY.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="flex items-start gap-3 hover:text-[#d90429] transition-colors"
                >
                  <Instagram className="w-5 h-5 text-[#d90429] shrink-0 mt-0.5" />
                  <span>{COMPANY.instagramHandle}</span>
                </a>
              </li>
              <li>
                <a
                  href={COMPANY.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook"
                  className="flex items-start gap-3 hover:text-[#1877f2] transition-colors"
                >
                  <Facebook className="w-5 h-5 text-[#1877f2] shrink-0 mt-0.5" />
                  <span>Facebook</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display uppercase tracking-wider text-white font-bold mb-5">
              Endereço
            </h3>
            <div className="flex items-start gap-3 text-gray-300 text-sm">
              <MapPin className="w-5 h-5 text-[#d90429] shrink-0 mt-0.5" />
              <span>
                Rua Delfon e Luiza Bressan, nº 440
                <br />
                Condomínio Reserva Imperial
                <br />
                Ribeirão Preto/SP
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-display uppercase tracking-wider text-white font-bold mb-5">
              Links Rápidos
            </h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li><a href="#home" className="hover:text-[#d90429] transition-colors">Início</a></li>
              <li><a href="#servicos" className="hover:text-[#d90429] transition-colors">Serviços</a></li>
              <li><a href="#sobre" className="hover:text-[#d90429] transition-colors">Sobre</a></li>
              <li><a href="#area" className="hover:text-[#d90429] transition-colors">Área de Atendimento</a></li>
              <li><a href="#depoimentos" className="hover:text-[#d90429] transition-colors">Depoimentos</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#2d3748] flex flex-col md:flex-row justify-between items-center gap-4 text-gray-500 text-xs uppercase tracking-wider">
          <span data-testid="copyright">
            © {new Date().getFullYear()} Auto Socorro Ventania — Todos os direitos reservados
          </span>
          <span className="text-gray-600">
            Guincho 24h Ribeirão Preto · Auto Socorro · Reboque
          </span>
        </div>
      </div>
    </footer>
  );
};
